import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap justify-between gap-x-3 gap-y-1 text-[11px] text-neutral50" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase tracking-wider" }, "Prazos · horário de Brasília"),
  /*#__PURE__*/_createElementVNode("span", null, "clique numa linha para ver só aqueles plantões")
], -1)
const _hoisted_3 = ["aria-pressed", "data-state", "data-testid", "onClick"]
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = { class: "flex min-w-0 flex-col" }
const _hoisted_6 = { class: "text-sm font-semibold text-textPrimary" }
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { class: "col-span-2 flex flex-col gap-1 md:col-span-1" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["data-testid"]

import { computed } from 'vue'

import type {
  PriorityBandsDto,
  PriorityConfig,
  PrioritySlaBand,
  PrioritySlaState,
  PriorityTab
} from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { buildPrioritySlaClockLines } from '../slaClock'
import type { PrioritySlaClockTone } from '../slaClock'
import { PRIORITY_SLA_TEXT_CLASS } from '../slaFormat'

/**
 * Relógio em linhas (M3): uma linha por prazo, countdown grande, quantos
 * vencem nele e a barra de cumpridos. Clicar liga/desliga `slaBand` (a página
 * decide; aqui só se emite). Sem `aria-live`: o countdown muda todo segundo.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PrioritySlaClock',
  props: {
    bands: {},
    tab: {},
    activeBand: {},
    nowMs: {},
    config: {},
    testId: { default: 'priority-sla-clock' }
  },
  emits: ["toggle-band"],
  setup(__props: any, { emit }) {

const props = __props;





const lines = computed(() =>
  buildPrioritySlaClockLines(props.bands, props.tab, props.nowMs, props.config)
)

const LINE_CLASS: Record<PrioritySlaState, string> = {
  OVERDUE: 'bg-red-50',
  URGENT: 'bg-orange-50',
  ATTENTION: 'bg-amber-50',
  ON_TIME: 'bg-white',
  DONE: 'bg-white',
  NOT_STARTED: 'bg-white'
}

const SEGMENT_CLASS: Record<PrioritySlaClockTone, string> = {
  ok: 'bg-green-600',
  info: 'bg-blue-500',
  crit: 'bg-red-600',
  warn: 'bg-orange-500',
  mute: 'bg-neutral50/30'
}

return (_ctx: any,_cache: any) => {
  return (lines.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "flex flex-col gap-1.5 rounded-lg border border-lightGray30 bg-white p-3",
        "aria-label": "Prazos do SLA",
        "data-testid": _ctx.testId
      }, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lines.value, (line) => {
          return (_openBlock(), _createElementBlock("button", {
            key: line.band,
            type: "button",
            class: _normalizeClass(["grid grid-cols-[auto_1fr] items-center gap-x-4 gap-y-1.5 rounded-md border px-3 py-2 text-left md:grid-cols-[minmax(130px,auto)_1fr_minmax(200px,280px)]", [
        LINE_CLASS[line.state],
        _ctx.activeBand === line.band
          ? 'border-primary shadow-[inset_0_0_0_1px_theme(colors.primary)]'
          : 'border-lightGray30'
      ]]),
            "aria-pressed": _ctx.activeBand === line.band,
            "data-state": line.state,
            "data-testid": `${_ctx.testId}-line-${line.band}`,
            onClick: ($event: any) => (emit('toggle-band', line.band))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["font-mono text-2xl font-bold tabular-nums", _unref(PRIORITY_SLA_TEXT_CLASS)[line.state]]),
              "data-testid": `${_ctx.testId}-line-${line.band}-clock`
            }, _toDisplayString(line.clock), 11, _hoisted_4),
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(line.title), 1),
              _createElementVNode("span", {
                class: "text-xs text-neutral50",
                "data-testid": `${_ctx.testId}-line-${line.band}-description`
              }, _toDisplayString(line.description), 9, _hoisted_7)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("span", {
                class: "flex h-1.5 overflow-hidden rounded-[3px] bg-lightGray30",
                role: "img",
                "aria-label": `${line.done} de ${line.total} cumpridos`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.segments, (segment, index) => {
                  return (_openBlock(), _createElementBlock("i", {
                    key: index,
                    class: _normalizeClass(["block h-full", SEGMENT_CLASS[segment.tone]]),
                    style: _normalizeStyle({ width: `${line.total ? (segment.count / line.total) * 100 : 0}%` })
                  }, null, 6))
                }), 128))
              ], 8, _hoisted_9),
              _createElementVNode("span", {
                class: "text-[11px] text-neutral50",
                "data-testid": `${_ctx.testId}-line-${line.band}-progress`
              }, _toDisplayString(line.progress), 9, _hoisted_10)
            ])
          ], 10, _hoisted_3))
        }), 128))
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})